import WithData from './component'

export default WithData
